module.exports = __webpack_public_path__ + "static/woman-rotary-phone-square.4ac086aa.jpg";